import { Box, FormLabel, Typography, Skeleton } from "@mui/material";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

const InvoiceShowCheckout = ({ invoice }) => {
    const WithSkeleton = ({ loading, children }) =>
        loading ? <Skeleton variant="text" width={80} /> : children;

    const invoiceNotes = invoice?.notes || '-';
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CheckCircleRoundedIcon sx={{ color: 'primary.main' }} />
                    <Typography variant='h6' sx={{ color: 'primary.main' }}>Finalização</Typography>
                </Box>
                <Box sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: 2,
                }}>
                    <Box>
                        <FormLabel sx={{ color: 'text.primary' }}><b>Informações adicionais</b></FormLabel>
                        <WithSkeleton loading={!invoice}>
                            <Typography>{invoiceNotes}</Typography>
                        </WithSkeleton>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default InvoiceShowCheckout;